<ng-container
  *appLet="{
    appCopy: appCopy$ | async,
    homeCopy: homeCopy$ | async,
    isFlowPage: isFlowPage$ | async,
    culture: culture$ | async,
    isFlightsPage: isFlightsPage$ | async,
    isUpliftPage: isUpliftPage$ | async,
    isHomePage: isHomePage$ | async,
    showSearchWidget: getShowModifySearchWidget$ | async,
    mobileStyle: mobileStyle$ | async,
    disruptionBanners: disruptionBanners$ | async,
    selectedJourneys: (selectedJourneys$ | async),
    featIsOn413: !gbs.growthBook.isOff(GrowthBookFeatureKeys.FEAT_US413_MONEY_BACK_GUARANTEE_ON_FRONT_PAGE),
    featStringValue413: gbs.getFeatureStringValue(GrowthBookFeatureKeys.FEAT_US413_MONEY_BACK_GUARANTEE_ON_FRONT_PAGE),
    featIsOn561: gbs.growthBook.isOn(GrowthBookFeatureKeys.FEAT_US561_STICKY_FLIGHT_SEARCH_ON_FRONT_PAGE),
    featStringValue561: gbs.growthBook.getFeatureValue(GrowthBookFeatureKeys.FEAT_US561_STICKY_FLIGHT_SEARCH_ON_FRONT_PAGE, ''),
    featIsOn3387: gbs.growthBook.isOn('feat-003387-aa-test'),
  } as $comp"
>
  <app-loader
    *ngIf="(doShowLoader$ | async) && (flightSearchInProgress$ | async) === false"
    [loadingText]="$comp.appCopy?.loadingCopy"
  ></app-loader>
  <app-flights-loader
    *ngIf="flightSearchInProgress$ | async">
  </app-flights-loader>
  @if ($comp.disruptionBanners) {
    <div #disruptionBanners>
      @for (banner of $comp.disruptionBanners; track $index) {
        @if(shouldShowBanner(banner)) {
          <app-disruption-banner
            [banner]="banner">
          </app-disruption-banner>
        }
      }
    </div>
  }
  <div #appHeader>
    <app-header
      *ngIf="$comp.appCopy"
      (scrollTop)="onScrollTop()"
      [cmsAppCopy]="$comp.appCopy"
      [cmsCopy]="$comp.appCopy.header"
    ></app-header>
  </div>
  <div id="scanbotContainer"></div>
    <div class="scroll-container" [id]="scrollContainerId" [style.height]="contentHeight + 'px'">
      <main
        [style.min-height]="mainMinHeight + 'px'"
        [attr.data-version]="EnvironmentService.environment.appVersionNumber"
        id="main"
      >
        <div
          *ngIf="$comp.appCopy && ($comp.isHomePage || $comp.isFlightsPage) && $comp.homeCopy"

          [ngStyle]="background && $comp.isHomePage && !isVideoBackground ? {
            'background-image': 'url('+$comp.homeCopy?.[background]?.url+')'
          } : {}"
          [ngClass]="{
            'visually-hidden': $comp.isFlightsPage && !$comp.showSearchWidget,
            'mb-0 pb-0' : (!gbs.growthBook.isOff(GrowthBookFeatureKeys.FEAT_US344_VERIFIED_BY_NORSE)
                && gbs.getFeatureStringValue(GrowthBookFeatureKeys.FEAT_US344_VERIFIED_BY_NORSE) === 'b'),
            'home__wrapper': !!background && $comp.isHomePage,
            'feat2280-b': gbs.growthBook.isOn('feat-002280-home-page-background-image-size') && gbs.growthBook.getFeatureValue('feat-002280-home-page-background-image-size', '') === 'b',
          }"
        >
          <app-search
            [isFlightsPage]="!!$comp.isFlightsPage"
            [isHomePage]="!!$comp.isHomePage"
            [appCopy]="$comp.appCopy"
            [cmsCopy]="$comp.appCopy[CmsSubKeys.searchWidgetFull]"
            [background]="!!background && $comp.isHomePage"
          ></app-search>
          @if (background && $comp.isHomePage && isVideoBackground) {
            <video autoplay [muted]="true" loop>
              <source [src]="$comp.homeCopy?.[background]?.url" type="video/mp4">
            </video>
          }
          @if (
            appCopy &&
            $comp.isHomePage &&
            ($comp.culture === "en-US" || $comp.culture === "en-GB") &&
            $comp.featIsOn413 &&
            ($comp.featStringValue413 === "b")
          ) {
            <div class="mt-3">
              <app-money-back-guarantee-popup
                [title]="$comp.appCopy.moneyBackGuaranteeTitle"
                [description]="$comp.appCopy.moneyBackGuaranteeDescription"
                [note]="$comp.appCopy.moneyBackGuaranteeTerms"
                [contentTitle]="$comp.appCopy.moneyBackGuaranteeSubtitle"
                [withReverseText]="true"
              ></app-money-back-guarantee-popup>
            </div>
          }
          @if (
            !gbs.growthBook.isOff(GrowthBookFeatureKeys.FEAT_US344_VERIFIED_BY_NORSE) &&
            (
              gbs.getFeatureStringValue(GrowthBookFeatureKeys.FEAT_US344_VERIFIED_BY_NORSE) === 'b' ||
              gbs.getFeatureStringValue(GrowthBookFeatureKeys.FEAT_US344_VERIFIED_BY_NORSE) === 'c'
            ) && $comp.isHomePage
          ) {
            <app-verified-by-norse
              [appCopy]="$comp.appCopy"
            ></app-verified-by-norse>
          }
        </div>
        <router-outlet></router-outlet>
      </main>
      <app-footer
        *ngIf="!$comp.isFlowPage && $comp.appCopy && $comp.culture"
        [cmsCopy]="$comp.appCopy.footer"
        [navCopy]="$comp.appCopy.footerNavigation"
        [isFlowPage]="$comp.isFlowPage ?? false"
        [isUpliftPage]="$comp.isUpliftPage ?? false"
        [culture]="$comp.culture"
      ></app-footer>
  </div>
</ng-container>
<app-svg-definitions></app-svg-definitions>
<app-tooltip></app-tooltip>
